var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import LogoLoader from './logo-loader';
import NestedList from './name-loader';
import Line from './title-loader';
import Lines from './recurring-view-loader';
var withEither = function (EitherComponent) { return function (Component) { return function (_a) {
    var _b = _a.isReady, isReady = _b === void 0 ? true : _b, props = __rest(_a, ["isReady"]);
    return (isReady ? React.createElement(Component, __assign({}, props)) : React.createElement(EitherComponent, null));
}; }; };
export var WithBusinessInfoLoader = function (Component) {
    return withEither(function () { return React.createElement(LogoLoader, null); })(Component);
};
export var WithCustomerLoader = function (Component) {
    return withEither(function () { return React.createElement(NestedList, null); })(Component);
};
export var WithTitleLoader = function (Component) {
    return withEither(function () { return React.createElement(Line, null); })(Component);
};
export var WithStatusLoader = function (Component) {
    return withEither(function () { return React.createElement(Line, null); })(Component);
};
export var WithQuoteInfoLoader = function (Component) {
    return withEither(function () { return React.createElement(NestedList, null); })(Component);
};
export var WithInvoiceInfoLoader = function (Component) {
    return withEither(function () { return React.createElement(NestedList, null); })(Component);
};
export var WithRecurringViewLoader = function (Component) {
    return withEither(function () { return React.createElement(Lines, null); })(Component);
};
//# sourceMappingURL=loaders-builder.js.map